<template>
    <!--
        作者：bbc_team
        时间：2023-06-08
        描述：超链接选择
    -->
    <el-dialog title="超链接设置" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="dialogFormVisible">
        <!--内容-->
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="产品" name="goods">
                <Goods v-if="activeName == 'goods'" @changeData="activeDataFunc"></Goods>
            </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer d-b-c">
            <div class="flex-1">
                <div v-if="activeData != null" class="d-s-s d-c tl">
                    <p class="text-ellipsis setlink-set-link">
                        <span>当前链接：</span>
                        <span class="gray9">{{ activeData.type }}</span>
                        <span class="p-0-10 gray">/</span>
                        <span class="blue">{{ activeData.name }}</span>
                    </p>
                    <p class="text-ellipsis gray" style="font-size: 10px;">{{ activeData.url }}</p>
                </div>
                <div v-else class="tl">
                    暂无
                </div>
            </div>
            <div class="setlink-footer-btn">
                <el-button size="small" @click="dialogFormVisible(false)">取 消</el-button>
                <el-button size="small" type="primary" @click="dialogFormVisible(true)">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import Goods from "./part/Goods.vue";
    export default {
        components: {
            Goods
        },
        props: ["is_linkset"],
        data() {
            return {
                /*是否显示*/
                dialogVisible: true,
                /*选中的链接*/
                activeData: null,
                activeName: "goods"
            };
        },
        created() {
            this.dialogVisible = this.is_linkset;
        },
        methods: {
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit("closeDialog", this.activeData);
                } else {
                    this.$emit("closeDialog", null);
                }
            },

            /*页面返回值*/
            activeDataFunc(e) {
                this.activeData = e;
            }
        }
    };
</script>

<style>
    .marketing-box .el-tabs__item {
        font-size: 12px;
    }
    .setlink-footer-btn {
        width: 160px;
    }
    .setlink-set-link {
        width: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/setlink/Setlink.vue